import { createModuleI18nNamespaces } from "src/system/createModuleI18nNamespaces.ts";
import type { NamespaceTester } from "src/lib/i18next/types.ts";
import { getAllModulesIds } from "src/system/getAllModulesIds.ts";
import { ResourceEnum } from "src/constants/constants.ts";

const resources = (
  Object.keys(ResourceEnum) as Array<keyof typeof ResourceEnum>
).map((key) => ResourceEnum[key]);

const isResourceListNs = (ns: string) => (resource: string) => {
  const namespace = createModuleI18nNamespaces();
  return namespace.list(resource) === ns;
};

export const resourceList: NamespaceTester = (ns: string, lang: string) => {
  const resource = resources.find(isResourceListNs(ns));

  if (resource) {
    const modules = getAllModulesIds();
    const lists = import.meta.glob("../../../admin/modules/*/lists/**/*.json");
    for (let i = 0; i < modules.length; i++) {
      const moduleId = modules[i];
      const relatePath = `../../../admin/modules/${moduleId}/lists/${resource}/list.${lang}.json`;

      if (lists[relatePath]) {
        return `src/admin/modules/${moduleId}/lists/${resource}/list.${lang}.json`;
      }
    }
    throw new Error("cannot load list translations");
  }
};
